import { tabs } from '../../../../../../views/dashboard/company/CompanyDashboard';

export default {
  title: 'Tableau de bord',
  tabs: {
    [tabs.general]: 'Général',
    [tabs.overview]: 'Aperçu',
    [tabs.orders]: 'Commandes par source',
    [tabs.google]: 'Google',
    [tabs.customers]: 'Clients',
    [tabs.order_conversion]: 'Conversion des commandes',
    [tabs.mobile_app]: 'App mobile',
  },
  date_range: {
    this_month: 'Ce mois',
    last_month: 'Mois dernier',
    last_week: 'Semaine dernière',
    this_week: 'Cette semaine',
    this_year: 'Cette année',
    last_year: 'Année dernière',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    all: 'Tout',
  },
  buttons: {
    view_key_info: 'Voir infos clés',
  },
  empty_franchise: {
    description:
      "Cette enseigne n'a pas encore de restaurant. Choisissez une autre enseigne dans le menu pour voir ses chiffres.",
  },
};
